var ActionformModalAbstract = ( function($) {

    // Abstract class
    var Self = ActionformModalAbstract = function () {
    };
    Self.className = 'ActionformModalAbstract';

    var def = function (var1, var2) {
        for (var i = 0, len = arguments.length; i < len; i++) {
            if (typeof arguments[i] !== 'undefined') {
                return arguments[i];
            }
        }
        return undefined;
    };

    Self.def = def;

    Self.prototype.init = function (options) {
        var that = this;
        that.initVars(options);
        that.initEventHandlers();
    };

    Self.prototype.initVars = function (options) {
        var that = this;

        that.title = options.modal_title || '';

        that.classes = that.classes || {};
        that.classes = $.extend({

            modal: 'actionform-modal',
            render_modal: options.modal_trigger_class || 'js-render-actionform-modal',

        }, that.classes);

        that.initDomElements(options);

        that.modal_options = that.modal_options || {};

        that.modal_options = $.extend({

            mobile_fullscreen: true

        }, that.modal_options, options.modal_options || {});
    };

    Self.prototype.initDomElements = function (options) {
        var that = this;
        that.content = options.modal_content;
    };

    Self.prototype.initEventHandlers = function () {
        var that = this;

        $.sa.$document.on('click', '.' + that.classes.render_modal, function () {
            that.renderModal();
        });
    };

    Self.prototype.renderModal = function() {
        var that = this,
            options = that.getModalOptions();
        
        $.uiModal(options);
    };
    
    Self.prototype.getModalOptions = function () {
        var that = this,
            options = $.extend({
                        header_title: that.title,
                        content: $(that.content).clone(),
                    },
                    that.modal_options
                );

        options.onOpen = function ($modal_wrapper, modal) {
            var onOpen = that.modal_options['onOpen'] || function () {};
            // call native callback
            that.onOpen($modal_wrapper, modal);
            // call custom callback
            onOpen($modal_wrapper, that);
        };

        return options;
    };

    Self.prototype.onOpen = function ($modal_wrapper, modal) {
        var that = this;

        $modal_wrapper.addClass(that.classes.modal);
    };

    return Self;

})($);